import { useEffect } from 'react'
import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom'
import { Navbar } from './components/Navbar'
import { Footer } from './components/Footer'
import { HomePage } from './pages/HomePage'
import DocsPage from './pages/DocsPage'

/**
 * The landing SPA is a separate bundle from the admin dashboard. When something
 * inside it (e.g. RegisterModal) navigates to an admin/dashboard path, react-router
 * would only match our own routes — so we force a full page load, which lets the
 * server hand back the correct bundle.
 */
function ExternalRedirect() {
  const location = useLocation()
  useEffect(() => {
    const path = location.pathname
    if (path.startsWith('/admin') || path.startsWith('/dashboard')) {
      window.location.replace(path)
    }
  }, [location.pathname])

  const path = location.pathname
  if (path.startsWith('/admin') || path.startsWith('/dashboard')) {
    return null
  }
  return <Navigate to="/" replace />
}

function Layout() {
  return (
    <div className="landing-page flex min-h-screen flex-col bg-dash-bg text-dash-text antialiased">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}

export function LandingApp() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/docs" element={<DocsPage />} />
        {/* "Try it" is just the home demo — deep-link to the anchor. */}
        <Route path="/try-it" element={<Navigate to="/#demo" replace />} />
        {/* Legacy / alternate doc URLs collapse into the single docs page. */}
        <Route path="/access-levels" element={<Navigate to="/docs" replace />} />
        <Route path="/api-documentation" element={<Navigate to="/docs" replace />} />
      </Route>
      {/* Cross-bundle paths (admin) + genuine 404s. */}
      <Route path="*" element={<ExternalRedirect />} />
    </Routes>
  )
}
